import { axios } from '@Root/API'

export const edit = (contactId, payload) => {
	return axios.post(`contact/${contactId}/additional-field`, payload)
}
